module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoRgIt.d1e41148.otf";